/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { selectFormHasAiMarkings } from '#selectors/entities/modelAiReview.js';
import Sp3AiLegend from './Sp3AiLegend.jsx';

const mapStateToProps = (state, ownProps) => ({
  visible: selectFormHasAiMarkings(ownProps.form)(state),
});

export default connect(mapStateToProps)(Sp3AiLegend);
